import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_mt-a" }
const _hoisted_2 = { "data-qa": "project-card:LastUpdate" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "gfu-bt gfu-bt--caption _tc--lighter" }, "Last update:", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */)
  ]))
}